import { render, staticRenderFns } from "./AsStampPage.vue?vue&type=template&id=3af4654d"
import script from "./AsStampPage.vue?vue&type=script&lang=js"
export * from "./AsStampPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports